import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=3ce42074&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=ts&"
export * from "./deal.vue?vue&type=script&lang=ts&"
import style0 from "./deal.vue?vue&type=style&index=0&id=3ce42074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce42074",
  null
  
)

export default component.exports